import React from 'react';

const TeamSection = () => {
  return (
    <div className="flex md:mt-4 mt-2 md:flex-row items-stretch bg-[#122112] p-4 md:p-14 rounded-md gap-6 md:gap-8">
      {/* Left Image */}
      <div className="w-full md:w-1/2">
        <div className="h-full">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744926935/image_15_agilmg.png"
            alt="Farmers Network"
            className="rounded-md w-full h-full object-cover max-h-[300px] md:max-h-full"
          />
        </div>
      </div>

      {/* Right Text */}
      <div className="w-full md:w-1/2 text-white flex flex-col justify-between">
        <div>
          <h2 className="text-[14px] md:text-[36px] font-bold leading-tight">
            <span className="text-[#FDBD26]">Hear from </span>
            the team
          </h2>
          <p className="text-[8px] md:text-[25px] font-normal mt-2 md:mt-4 leading-[1.3]">
            <strong className="text-[16px] md:text-[40px]">“</strong> Entrepreneurs are the reason why we exist. As an organization we cannot thrive
            unless we enable SMMEs grow sustainably <strong className="text-[16px] md:text-[40px]">”</strong>
          </p>
        </div>
        <div className="text-[10px] md:text-[32px] font-bold mt-2 md:mt-6 leading-snug">
          <p>Allan Oyier -</p>
          <p>Founder & CEO Farmers</p>
          <p>Networks</p>
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
